import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { selectPermissions, selectReadonly } from 'store/Services/selectors';

const ID = 'description';

const Description = ({ serviceId, description, updateService, entity }) => {
  const intl = useIntl();
  const readOnly = useSelector(selectReadonly);
  const permissions = useSelector(selectPermissions);
  const disabled = (entity !== 'servicesGeneral' && readOnly) || !permissions.update.allowed;
  const isExpanded = useExpandable('general', ID, description, serviceId);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'manage.detail.tab.general.description' }) } tab="general" id={ ID }>
      <MarkdownEditor
        value={ description }
        onBlur={ (value) => updateService(serviceId, { description: value }) }
        disabled={ disabled }
        minHeight={ 49 }
      />
    </ExpandableWrapper>
  );
};

export default Description;
